import RestEndpointsEnum from "../models/RestEndpointsEnum";
import { buildRestUrlWithQuery, buildAuthHeadersForFetch } from "./RestService";
import IUserUI from "../models/IUserUI";
import ISupplierModel from "../models/ISupplierModel";
import IQBOCustomerDTO from "../models/QuickBooks Online/IQBOCustomerDTO";

const searchCustomers = async (name: string, userModel: IUserUI, supplierModel: ISupplierModel): Promise<IQBOCustomerDTO[]> => {
    const url = buildRestUrlWithQuery({
        endpoint: RestEndpointsEnum.QBOSearchCustomers,
        query: { name },
    });

    const headers = buildAuthHeadersForFetch({
        userModel,
        supplierModel,
    });

    const response = await fetch(url, {
        method: "GET",
        headers,
    });

    if (!response.ok) {
        throw new Error(`Failed to search QBO customers: ${response.statusText}`);
    }

    const data = await response.json();
    return data.customers ?? data;
};

const QboService = {
    searchCustomers,
};

export default QboService;
